export const SET_ACCOUNTS = "SET_ACCOUNTS";
export const ADD_ACCOUNT_DETAILS = "ADD_ACCOUNT_DETAILS";
export const ADD_PORTFOLIO = "ADD_PORTFOLIO";
export const ADD_JOINT_OWNER = "ADD_JOINT_OWNER";
export const ADD_WRAPPER_DETAILS = "ADD_WRAPPER_DETAILS";

export function setAccounts(accounts) {
    return {
        type: SET_ACCOUNTS,
        accounts
    };
}

export function addAccountDetails(accountNumber, details) {
    return {
        type: ADD_ACCOUNT_DETAILS,
        accountNumber,
        details
    };
}

export function addPortfolio(accountNumber, portfolio) {
    return {
        type: ADD_PORTFOLIO,
        accountNumber,
        portfolio
    };
}

export function addJointOwners(accountNumber, ownerRelationships) {
    return {
        type: ADD_JOINT_OWNER,
        accountNumber,
        ownerRelationships
    };
}

export function addWrapperDetails(accountNumber, wrapperDetails) {
    return {
        type: ADD_WRAPPER_DETAILS,
        accountNumber,
        wrapperDetails
    };
}
